import React, {Component} from 'react';
import TextFieldGroup from "../../common/TextFieldGroup";
import {connect} from "react-redux";
import Groups from "../../../ducks/Groups";
import Things from "../../../ducks/Things";
import {bindActionCreators} from "redux";
import CheckboxListComponent from "../../common/CheckboxListComponent";
import {validateInput} from "../../../validations/domainCreate";
import toastr from "toastr";
import * as _ from "lodash";
import Slider from 'rc-slider';
import {WhiteSpinner} from '../../common/Spinner/index';
import {HandleSlider} from "../../common/HandleSlider";

const { Range } = Slider;

class GroupUpdate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            pointOfContactDetails: "",
            roboCallPocPhoneNumber1:"",
            roboCallPocPhoneNumber2:"",
            errors: {},
            overSpeedingThreshold: null,
            vehicles: [],
            haveVehicles: false,
            selectAll: false,
            selectedVehicles: [],
            isEditMode: false,
            loader: false,
            tmin: -30,
            tmax: 70,
            hmin: -40,
            hmax: 100,
            tmaxValue:0,
            tminValue:0,
            hmaxValue:0,
            hminValue:0
        }
    }

    async componentDidMount() {
        let companyInfo = JSON.parse(localStorage.getItem("companyInfo"));

        await this
            .props
            .thingsActions
            .getGroupVehicles({groupId: companyInfo.groupId});

        await this
            .props
            .actions
            .getSingleToUpdate(this.props.match.params.id);



        let selectedVehicles = [];
        let vehicles = [];
        _.forEach(this.props.group.things, item => {
            let vehicle = {
                _id: item._id,
                name: item.name || "N/A",
                checked: true,
                imei: item.imei || "N/A"
            };
            selectedVehicles.push(item._id);
            vehicles.push(vehicle)
        })
        _.forEach(this.props.group.allThings, item => {
            let vehicle = {
                _id: item._id,
                name: item.name || "N/A",
                checked: false,
                imei: item.imei || "N/A"
            };
            vehicles.push(vehicle)
        })
         _.forEach(this.props.vehicles, (item) => {

            let vehicle = {
                _id: item._id,
                name: item.name || "N/A",
                checked: false,
                imei: item.imei || "N/A"
            };
            vehicles.push(vehicle);
        });

        this.setState({
            ...this.state,
            vehicles,
            haveVehicles: vehicles.length? true : false,
            name: this.props.group.name,
            pointOfContactDetails: this.props.group.description,
            selectedVehicles: selectedVehicles,
            tmaxValue : this.props.group.highTemperatureThreshold || 0,
            tminValue : this.props.group.lowTemperatureThreshold || 0,
            hmaxValue : this.props.group.highHumidityThreshold || 0,
            hminValue : this.props.group.lowHumidityThreshold || 0,
            tmin : this.props.group.tmin || -30,
            tmax : this.props.group.tmax || 70,
            hmin : this.props.group.hmin || -40,
            hmax : this.props.group.hmax || 100,

        });

    }
    isValid = () => {
        const {errors, isValid} = validateInput(this.state);

        if (!isValid) {
            this.setState({errors});
        }

        return isValid;
    };
    checkBoxListSelectAll = () => {

        let vehicles = this.state.vehicles;
        let selectedVehicles = this.state.selectedVehicles;

        let isSelectAll = this.state.selectAll;
        if (vehicles.length > 0) {
            for (let i = 0; i < vehicles.length; i++) {
                let item = vehicles[i];

                if (!isSelectAll) {
                    item.checked = true;
                    selectedVehicles.push(item._id);
                } else {
                    item.checked = false;
                    let index = selectedVehicles.findIndex(obj => {
                        return obj === item._id;
                    });
                    if (index > -1) {
                        selectedVehicles.splice(index, 1);
                    }
                }

            vehicles[i] = item;
            }
        }
        this.setState({
            ...this.state,
            vehicles,
            selectedVehicles,
            selectAll: !isSelectAll
        });
    };
    checkBoxListChanged = (value) => {
        let vehicles = this.state.vehicles;
        let selectedVehicles = this.state.selectedVehicles;
        let isSelectAll = this.state.selectAll;
        if (vehicles.length > 0) {
            for (let i = 0; i < vehicles.length; i++) {
                let item = vehicles[i];
                if (i === parseInt(value, 10)) {
                    item.checked = !item.checked;
                    if (item.checked) {
                        selectedVehicles.push(item._id);
                    } else {
                        let index = selectedVehicles.findIndex(obj => {
                            return obj === item._id;
                        });
                        if (index > -1) {
                            if(isSelectAll){
                                isSelectAll = false;
                            }
                            selectedVehicles.splice(index, 1);
                        }
                    }
                }
                vehicles[i] = item;
            }
        }
        this.setState({
            ...this.state,
            vehicles,
            selectedVehicles,
            selectAll: isSelectAll
        });
    };

    onChange = e => {
        this.setState({
            [e.target.name]: e.target.value,
            errors: {
                ...this.state.errors,
                [e.target.name]: ''
            }
        });
    };
    onSubmit = async e => {
        e.preventDefault();
        if (this.isValid()) {
            try {
                let companyInfo = JSON.parse(localStorage.getItem("companyInfo"));
                let body = {
                    name: _.trim(this.state.name),
                    things: this.state.selectedVehicles,
                    description: _.trim(this.state.pointOfContactDetails),
                    highTemperatureThreshold:this.state.tmaxValue,
                    lowTemperatureThreshold:this.state.tminValue,
                    highHumidityThreshold:this.state.hmaxValue,
                    lowHumidityThreshold:this.state.hminValue
                }
                this.setState({
                    ...this.state,
                    loader: true
                })
                await this
                    .props
                    .actions
                    .UpdateSubGroup(body,this.props.match.params.id);
                toastr.success("Group Updated Successfully!");
                this.setState({
                    ...this.state,
                    loader: false
                })
                this
                    .props
                    .history
                    .push("/groups");
            } catch (e) {
                this.setState({
                    ...this.state,
                    loader: false
                })
                toastr.error(e.response ? e.response.data.message : e);
            }

        }
    };
    searchVehicles = (e) => {

        const value = e.target.value;
        let vehicles = [];
        let selectedVehicles = this.state.selectedVehicles;
        if (value) {
             _.forEach(this.props.vehicles, (item) => {
                if (item.name.search(new RegExp(value, "i")) >= 0) {
                    let index = selectedVehicles.findIndex(obj => {
                        return obj === item._id;
                    });

                    vehicles.push({
                        _id: item._id,
                        name: item.name || "N/A",
                        checked: index > -1 ? true : false,
                        imei: item.imei || "N/A"
                    });
                }
            });

        } else {
            vehicles = _.map(this.props.vehicles, (item) => {
                let index = selectedVehicles.findIndex(obj => {
                    return obj === item._id;
                });
                return {
                    _id: item._id,
                    name: item.name || "N/A",
                    checked: index > -1 ? true : false,
                    imei: item.imei || "N/A"
                };
            });
        }
        this.setState({
            ...this.state,
            vehicles
        });
    }
    changeOverspeedingThreshold = (value)=> {

       this.setState({...this.state, overSpeedingThreshold: value})
    }
    onSliderChangeTemp = (value) => {
        this.setState({...this.state, tminValue :value[0] , tmaxValue: value[1]});
      };
    
      onSliderChangeHumidity = (value) => {
        this.setState({...this.state, hminValue : value[0], hmaxValue: value[1]});
      };
    render() {
        const loader = <WhiteSpinner key="1"/>;
        const {name, pointOfContactDetails,roboCallPocPhoneNumber1,roboCallPocPhoneNumber2} = this.state;
        const createBtnStyle= {
            "marginTop": '30px'
        };
        let trangeValue = [this.state.tminValue, this.state.tmaxValue];
        let hrangeValue = [this.state.hminValue, this.state.hmaxValue];
        return (
            <div>
                <div className="heading-container">
                    <h3 className="font-weight-bold">Update Group</h3>
                </div>
                <form onSubmit={this.onSubmit}>
                    <div className="row">
                        <div className="col">
                            <TextFieldGroup
                                onChange={this.onChange}
                                value={name}
                                type={"text"}
                                field={"name"}
                                label={"Group Name"}
                                placeholder={"Group name"}
                                error={this.state.errors.name}/>
                            <TextFieldGroup
                                onChange={this.onChange}
                                value={pointOfContactDetails}
                                type={"text"}
                                field={"pointOfContactDetails"}
                                label={"Description"}
                                placeholder={"Description"}/>
                                <div className='temperatureRange' style={{width: "400px", marginBottom: "20px"}}>
                                    <p style={{marginBottom:"20px"}}>Temeperature Range</p>
                                    <div style={{marginLeft:"15px",display:'flex', flexDirection:'column'}}>
                                    <label>Upper Limit : {this.state.tmaxValue}</label>
                                    <label>Lower Limit : {this.state.tminValue}</label>
                                        <Range
                                            value={trangeValue}
                                            min={this.state.tmin}
                                            max={this.state.tmax}
                                            onChange={this.onSliderChangeTemp}
                                            />
                                    </div>
                                </div>
                                <div className='humidityRange' style={{width: "400px", marginTop: "10px"}}>
                                    <p style={{marginBottom:"20px"}}>Humidity Range</p>
                                    <div style={{marginLeft:"15px",display:'flex', flexDirection:'column'}}>
                                        <label>Upper Limit : {this.state.hmaxValue}</label>
                                        <label>Lower Limit : {this.state.hminValue}</label>
                                        <Range
                                        value={hrangeValue}
                                        min={this.state.hmin}
                                        max={this.state.hmax}
                                        onChange={this.onSliderChangeHumidity}
                                        />
                                    </div>
                                </div>
                            <div>
                        </div>
                        <button className="btn auxo-primary-btn" style={createBtnStyle}>
                            {this.state.loader ? [loader] :  'Update'}</button>
                        </div>

                        <div className="col">
                        {this.state.haveVehicles ?  <div>
                            <ul className="nav nav-tabs" role="tablist">
                                <li className="nav-item">
                                    <a className={"nav-link active"}>Devices</a>
                                </li>
                            </ul>
                            <div className="tab-content access-tab mb-5">
                                <div className={"tab-pane fade show active"}>
                                    <CheckboxListComponent
                                        enableSearch = "true"
                                        selectAllCheck={this.state.selectAll}
                                        selectAllEnabled={this.state.vehicles.length ? true: false}
                                        search={this.searchVehicles}
                                        selectAll={this.checkBoxListSelectAll}
                                        onChange={this.checkBoxListChanged}
                                        data={this.state.vehicles && this
                                        .state
                                        .vehicles
                                        .map(item => ({mainTitle: item.name, subTitle: item.imei, checked: item.checked}))}/>
                                </div>
                            </div>
                            </div> : ""}

                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

GroupUpdate.propTypes = {};
GroupUpdate.defaultProps = {};
const mapStateToProps = state => {
    return {vehicles: state.things.groupVehicles, group: state.groups.group}
};
const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(Groups.creators, dispatch),
    thingsActions: bindActionCreators(Things.creators, dispatch),
    // permissionActions: bindActionCreators(permissionActions, dispatch)
});
export default connect(mapStateToProps, mapDispatchToProps)(GroupUpdate);
